import { memo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CompanyCard } from "../../components/about/companyCard";
import { CONFIG } from "../../constants/group-distribution.config";
import clsx from "clsx";

function GroupDistribution({ data }) {
  const { title, subTitle, coverImage, companyList } = data;
  const [styleConfig, setStyleConfig] = useState(null);
  const companyListLength = companyList.length;

  useEffect(() => {
    const mqNormal = window.matchMedia(`(min-width: ${1536 + 1}px)`);
    const mq1536 = window.matchMedia(`(min-width: ${992 + 1}px)`);
    const mq992 = window.matchMedia(`(min-width: ${600 + 1}px)`);
    const mq600 = window.matchMedia(`(min-width: ${0}px)`);

    const checkMediaQuery = () => {
      if (mqNormal.matches) {
        const config = CONFIG[5000][companyListLength];
        setStyleConfig(config);
      } else if (mq1536.matches) {
        console.log("1536");
        const config = CONFIG[1536][companyListLength];
        setStyleConfig(config);
      } else if (mq992.matches) {
        console.log("992");
        const config = CONFIG[992][companyListLength];
        setStyleConfig(config);
      } else if (mq600.matches) {
        console.log("600");
        const config = CONFIG[600][companyListLength];
        setStyleConfig(config);
      }
    };

    checkMediaQuery();
  }, [companyListLength]);

  return (
    <div className="root">
      <div className="cover-image">
        <div className="image">
          <img src={coverImage} alt="cover-image" />
        </div>
        <div className="text-container">
          <p className="title">{title}</p>
          <p className="sub-title">{subTitle}</p>
        </div>
      </div>
      {styleConfig && (
        <div className="company-card-container">
          {companyList.map((item, index) => (
            <div
              key={item.id}
              className={clsx("company-card-pos", `company-card-pos-${index + 1}`)}
              style={{
                top: styleConfig[index].top,
                left: styleConfig[index].left,
                right: styleConfig[index].right,
                bottom: styleConfig[index].bottom,
              }}
            >
              <CompanyCard
                icon={item.icon}
                title={item.title}
                linkListHtml={item.linkListHtml}
                isReverse={styleConfig[index].isRevert}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default memo(GroupDistribution);

GroupDistribution.propTypes = {
  data: PropTypes.object,
};
